const nav = document.querySelector('.latapin-direct-nav');
const trigger = nav?.querySelector('.latapin-direct-nav__services-trigger');
const menu = nav?.querySelector('.latapin-direct-nav__services-menu');
const scrollArea = nav?.querySelector('.latapin-direct-nav__inner');

if (trigger instanceof HTMLButtonElement && menu instanceof HTMLElement) {
  const positionMenu = () => {
    if (menu.hidden || !(nav instanceof HTMLElement)) return;

    const navRect = nav.getBoundingClientRect();
    const triggerRect = trigger.getBoundingClientRect();
    const edgePadding = 8;
    const preferredLeft = triggerRect.right - navRect.left - menu.offsetWidth;
    const maximumLeft = nav.clientWidth - menu.offsetWidth - edgePadding;
    const left = Math.max(edgePadding, Math.min(preferredLeft, maximumLeft));

    menu.style.left = `${left}px`;
  };

  const close = () => {
    trigger.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
  };

  trigger.addEventListener('click', () => {
    const opening = trigger.getAttribute('aria-expanded') !== 'true';
    trigger.setAttribute('aria-expanded', String(opening));
    menu.hidden = !opening;
    if (opening) positionMenu();
  });

  window.addEventListener('resize', positionMenu);
  scrollArea?.addEventListener('scroll', positionMenu, { passive: true });

  document.addEventListener('click', (event) => {
    if (event.target instanceof Node && !nav.contains(event.target)) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();
      trigger.focus();
    }
  });
}
